import { render, staticRenderFns } from "./DraggableModule.vue?vue&type=template&id=c3ba9454&scoped=true"
import script from "./DraggableModule.vue?vue&type=script&lang=js"
export * from "./DraggableModule.vue?vue&type=script&lang=js"
import style0 from "./DraggableModule.vue?vue&type=style&index=0&id=c3ba9454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ba9454",
  null
  
)

export default component.exports